<input
  type="tel"
  [class]="inputClass"
  [name]="name"
  [value]="partialValue"
  [disabled]="disabled"
  [autocomplete]="autocomplete"
  [required]="required"
  (input)="onInput($event)"
  (blur)="onBlur()"
  #phoneInputElement
/>
